import api from "./axios";

// List
export const getOrganizations = async (
    master,
    page = 1,
    limit = 100,
    search = "",
    filters = {}
) => {

    const response = await api.get(
        `/organization/${master}`,
        {
            params: {
                page,
                limit,
                search,
                ...filters,
            },
        }
    );

    return response.data;
};

// Get Single
export const getOrganization = (master, id) =>
  api.get(`/organization/${master}/${id}`);

// Create
export const createOrganization = (master, data) =>
  api.post(`/organization/${master}`, data);

// Update
export const updateOrganization = (master, id, data) =>
  api.patch(`/organization/${master}/${id}`, data);

// Delete
export const deleteOrganization = (master, id) =>
  api.delete(`/organization/${master}/${id}`);